const baseFontSize = 16;
const fontScale = 1.125;
export const fontSize = (step = 0) => fontSizeValue(step) / 16 + 'rem';
export const fontSizeValue = (step = 0) => Math.round(baseFontSize * fontScale ** step * 100) / 100;

export const breakpoints = {
  phone: 'screen and (min-width: 400px)',
  tablet: 'screen and (min-width: 768px)',
  desktop: 'screen and (min-width: 1200px)',
};

export const palette = {
  primary: '#34AC68',
  primaryLight: '#A8DBBE',
  primaryDark: '#2A8A53',

  primaryHover: '#E9F7EF',

  // White
  white: '#FFFFFF',

  // Gray
  gray15: '#FAFAFA',
  gray25: '#F3F2F3',
  gray35: '#F2F2F1',
  gray50: '#E6E6E6',
  gray100: '#CECDCD',
  gray200: '#B5B4B4',
  gray300: '#9D9B9B',
  gray400: '#848282',
  gray500: '#6B6868',
  gray600: '#524F4F',
  gray700: '#3A3636',
  gray800: '#211D1D',
  gray900: '#090404',
  gray1100: '#000000',

  // Green
  green100: '#E8F9EF',
  green200: '#CEEBDB',
  green300: '#A8DBBE',
  green400: '#7FCBA0',
  green500: '#59BB83',
  green600: '#34AC68',
  green700: '#2C9258',
  green800: '#257a4a',
  green900: '#1E623B',
  green1000: '#174D2F',

  // Red
  red100: '#EAF8F8',
  red200: '#C0EAEA',
  red300: '#F1B7AF',
  red400: '#EB968A',
  red500: '#E57666',
  red600: '#DF5845',
  red700: '#be4b3b',
  red800: '#175C5C',
  red900: '#7F3227',
  red1000: '#64281F',

  // Teal
  teal100: '#EAF8F8',
  teal200: '#C0EAEA',
  teal300: '#97DCDC',
  teal400: '#6DC6CD',
  teal500: '#43BFBF',
  teal600: '#24A3A3',
  teal700: '#1F8B8B',
  teal800: '#1A7474',
  teal900: '#155D5D',
  teal1000: '#155D5D',

  // System
  success: '#10B456',
  warning: '#FF794D',
  error: '#EC4634',
  destroy: '#FFD966',
  destroyHover: '#e0c561',

  // Dashboard
  border: '#E6E6E6',
  currency: '#fff',
  label: '#6B6868',
};

export const fontSizes = {
  xsmall: fontSize(-2),
  small: fontSize(-1),
  normal: fontSize(0),
  large: fontSize(1),
  xlarge: fontSize(2),
  xxlarge: fontSize(4),
  display: fontSize(6),
};

export const radii = {
  button: '8px',
  buttonSecondary: '4px',
};

export const shadows = {
  normal: '0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 0px 12px rgba(16, 24, 40, 0.03)',
};
